import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import PriorityHighRoundedIcon from "@mui/icons-material/PriorityHighRounded";
import AnnouncementRoundedIcon from "@mui/icons-material/AnnouncementRounded";
import RadioButtonUncheckedRoundedIcon from "@mui/icons-material/RadioButtonUncheckedRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import ThreePIcon from "@mui/icons-material/ThreeP";
import {
  Backdrop,
  CircularProgress,
  Divider,
  Popper,
  Table,
  TableSortLabel,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoreModal from "../../../../../app/core/components/CoreModal/CoreModal";
import CorePagination from "../../../../../app/core/components/CorePagination/CorePagination";
import CoreStatus from "../../../../../app/core/components/CoreStatus/CoreStatus";
import { ROLE, SUB_ROLE } from "../../../../../utils/constants/profiles";
import { GESTIONE_DOCUMENTI_TABLE_HEADER } from "../../../../../utils/constants/tables";
import { formattaDataOraIta } from "../../../../../utils/functions/date-utils";
import {
  useDoChangeStatusMutation,
  useDoPriorityDocMutation,
  useGetSingleDocumentIdQuery,
  useRejectDocumentMutation,
} from "../../../../api/admin/gestisciDocumentiApi";
import SchedaUtente from "../../../../common/SchedaUtente/SchedaUtente";
import SingleDocumentPage from "../../../../common/SingleDocumentPage/SingleDocumentPage";
import { actions } from "../../gestisciDocumentiSlice";
import { SkeletonsHorizontalLine } from "../../../../common/LoadingStuff/Skeletons/SkeletonsHorizontalLine";
import DocComposition from "../../../../../app/core/components/DocComposition/DocComposition";

const GestioneDocumentiTable = ({
  data,
  page,
  setPage,
  isLoading,
  orderDirection,
  setOrderDirection,
  valueToOrderBy,
  setValueToOrderBy,
  totalPages,
  isFetching,
  isPolling,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const appConfig = useSelector((state) => state.app.appConfig);
  const [isUserCardModalOpen, setIsUserCardModalOpen] = useState(false);
  const [isSingleDocumentModalOpen, setIsSingleDocumentModalOpen] =
    useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null); // Initialize as nul
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [noteEl, setNoteEl] = useState(null);
  const [titleNote, setTitleNote] = useState();
  const [isModalDocComposition, setIsModalDocComposition] = useState(false);
  const [listIdDocs, setListIdDocs] = useState(null);

  const popperRef = useRef();

  const docManagementState = useSelector((state) => state.docManagementSlice);
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const app = useSelector((state) => state.app);

  const dispatch = useDispatch();

  const { data: singleDoc } = useGetSingleDocumentIdQuery(selectedDoc, {
    skip: !selectedDoc,
  });

  const [rejectDocument, { isLoading: isRejectLoading }] =
    useRejectDocumentMutation();
  const [changeStatus] = useDoChangeStatusMutation();
  const [priorityDoc] = useDoPriorityDocMutation();

  useEffect(() => {
    function handleClickOutside(event) {
      // Verifica se il clic è avvenuto fuori dal Popper
      if (popperRef.current && !popperRef.current.contains(event.target)) {
        setAnchorEl(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popperRef]);

  useEffect(() => {
    if (data) {
      setListIdDocs(
        data.items
          .filter((el) => el.type !== "DocumentComposition")
          .map((el) => el.id)
      );
    }
  }, [data]);

  const handleSelectAllClick = () => {
    const selectedIds = docManagementState.selectedDocsIds;

    if (selectedIds.length === data?.items?.length) {
      dispatch(actions.setSelectedDocsIds([]));
    } else {
      let newSelected = [];
      data?.items.forEach((e) => newSelected.push(e.id));
      dispatch(actions.setSelectedDocsIds(newSelected));
    }
  };

  const handleSelectSingleDoc = (id) => {
    const selectedIndex = docManagementState.selectedDocsIds.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = [...docManagementState.selectedDocsIds, id];
    } else {
      newSelected = [
        ...docManagementState.selectedDocsIds.slice(0, selectedIndex),
        ...docManagementState.selectedDocsIds.slice(selectedIndex + 1),
      ];
    }
    dispatch(actions.setSelectedDocsIds(newSelected));
  };

  const isSelected = (id) =>
    docManagementState.selectedDocsIds.indexOf(id) !== -1;

  const closeModal = () => {
    setIsUserCardModalOpen(false);
    setIsSingleDocumentModalOpen(false);
  };

  const handleOpenSingleDoc = (doc) => {
    setSelectedDoc(doc);
    setIsSingleDocumentModalOpen(true);
  };

  const handleOpenModalDocComposition = (doc) => {
    setIsModalDocComposition(true);
    setSelectedDoc(doc);
  };

  const handleOpenUserCard = (userId) => {
    setSelectedUserId(userId);
    setIsUserCardModalOpen(true);
  };

  const handleRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  const navigateToPractice = (doc) => {
    if (ROLE.BUSINESS === app.role) {
      if (SUB_ROLE.OPERATOR === app.subRole)
        navigate(`/auth/operator/${t("managePractices")}/${doc.userId}`, {
          state: doc.userName,
        });
      else
        navigate(`/auth/business/${t("managePractices")}/${doc.userId}`, {
          state: doc.userName,
        });
    }
    if (ROLE.ADMIN === app.role) {
      navigate(`/auth/admin/${t("managePractices")}/${doc.userId}`, {
        state: doc.userName,
      });
    }
  };

  const handleRejectDocument = (doc) => {
    rejectDocument({
      id: doc.id,
      categoryId: doc.categoryId,
    })
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(t("DocsNotDiscarded"));
        } else {
          toast.success(t("DocDiscarded"));
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleChangeStatusDoc = (doc) => {
    const bodyStatus = {
      id: doc.id,
      status: doc.status === 5 ? 3 : doc.status === 6 ? 3 : 5,
    };
    changeStatus(bodyStatus).then((res) => {
      if (res.data.Result !== 1) {
        toast.error(t("DocStatus") + " " + t("not edited"));
      } else {
        toast.success(t("DocStatus") + " " + t("edited"));
      }
    });
  };

  const handleProrityDoc = (doc) => {
    const bodyPriority = {
      id: doc.id,
      isRead: doc.read ? false : true,
    };
    priorityDoc(bodyPriority).then((res) => {
      if (res.data.Result !== 1) {
        toast.error(t("DocNotEdited"));
      } else {
        toast.success(t("DocEdited"));
      }
    });
  };

  const handleClick = (event, note, title) => {
    if (anchorEl === event.currentTarget) {
      setAnchorEl(false);
      setNoteEl(null);
      setTitleNote(null);
    } else {
      setAnchorEl(event.currentTarget);
      setNoteEl(note);
      setTitleNote(title);
    }
  };

  function isIndeterminate(numberSelected, numberOfData) {
    return numberSelected > 0 && numberSelected < numberOfData;
  }

  return (
    <div className="w-full  p-4">
      <TableContainer sx={{ position: "relative" }}>
        <Backdrop
          className="bg-black bg-opacity-30"
          sx={{ position: "absolute", zIndex: 3 }}
          open={isLoading}
        >
          <CircularProgress style={{ color: app.colorPrimary }} />
        </Backdrop>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size="medium"
        >
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  indeterminate={isIndeterminate(
                    docManagementState.selectedDocsIds?.length,
                    data?.items?.length
                  )}
                  checked={
                    docManagementState.selectedDocsIds?.length ===
                    data?.items?.length
                  }
                  onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all documents" }}
                />
              </TableCell>
              {GESTIONE_DOCUMENTI_TABLE_HEADER().map((column) => (
                <TableCell
                  key={column.id}
                  align={
                    [t("practice")].includes(column.id) ? "center" : "left"
                  }
                  style={{ minWidth: column.minWidth }}
                >
                  <TableSortLabel
                    disabled={[
                      "confidence",
                      "actions",
                      "service",
                      "notes",
                    ].includes(column.id)}
                    active={valueToOrderBy === column.id}
                    direction={orderDirection}
                    onClick={() => handleRequestSort(column.id)}
                  >
                    {column.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isFetching && !isPolling ? (
            <TableBody>
              {[...Array(50)].map((_, i) => (
                <TableRow key={i}>
                  <TableCell colSpan={9}>
                    <SkeletonsHorizontalLine length={1} height={27} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody>
              {data?.items?.map((doc, idx) => {
                const isItemSelected = isSelected(doc.id);
                return (
                  <TableRow
                    className={
                      doc.read && !isItemSelected
                        ? "bg-amber-50 hover:shadow-md"
                        : "hover:shadow-md"
                    }
                    key={doc.id}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    selected={isItemSelected}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        onClick={(event) => event.stopPropagation()}
                        onChange={() => handleSelectSingleDoc(doc.id)}
                        inputProps={{ "aria-labelledby": doc.id }}
                      />
                    </TableCell>
                    <TableCell
                      align="left"
                      className={doc.status === 3 && "font-semibold"}
                    >
                      {doc.name.length > 25
                        ? doc.name.substring(0, 22) + "..."
                        : doc.name}
                    </TableCell>
                    <TableCell>
                      <CoreStatus status={doc.status} isSingular={true} />
                    </TableCell>
                    <TableCell
                      align="left"
                      className={doc.status === 3 && "font-semibold"}
                    >
                      {formattaDataOraIta(doc.createdAt)}
                    </TableCell>
                    <TableCell
                      align="left"
                      className={doc.status === 3 && "font-semibold"}
                    >
                      {doc.userName}
                    </TableCell>

                    <TableCell
                      align="left"
                      className={doc.status === 3 && "font-semibold"}
                    >
                      {doc.categoryName?.length > 30
                        ? doc?.categoryName.substring(0, 27) + "..."
                        : doc.categoryName}
                    </TableCell>
                    {doc.status !== 6 ? (
                      <TableCell>
                        <Tooltip title={t("UserNotes")}>
                          <IconButton
                            disabled={!doc.notes}
                            onClick={(e) =>
                              handleClick(e, doc.notes, t("UserNotes"))
                            }
                          >
                            <ThreePIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={t("OperatorNotes")}>
                          <IconButton
                            disabled={!doc.operatorNotes}
                            onClick={(e) =>
                              handleClick(
                                e,
                                doc.operatorNotes,
                                t("OperatorNotes")
                              )
                            }
                          >
                            <SpeakerNotesIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    ) : (
                      <TableCell>
                        <Tooltip title={t("DiscardNotes")}>
                          <IconButton
                            disabled={!doc.rejectionNotes}
                            className={
                              doc.rejectionNotes ? "text-red-700" : "text-gray"
                            }
                            onClick={(e) =>
                              handleClick(
                                e,
                                doc.rejectionNotes,
                                t("DiscardNotes")
                              )
                            }
                          >
                            <AnnouncementRoundedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    )}
                    <TableCell className="items-center" align="left">
                      <Tooltip
                        title={doc.read ? t("Deactivate") : t("Activate")}
                      >
                        <IconButton
                          onClick={() => handleProrityDoc(doc)}
                          className="w-10 h-10 "
                        >
                          <PriorityHighRoundedIcon
                            className={doc.read ? "text-red-700" : "text-gray"}
                          />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={t("Visualize")}>
                        <IconButton
                          onClick={
                            doc.type === "DocumentComposition"
                              ? () => handleOpenModalDocComposition(doc.id)
                              : () => handleOpenSingleDoc(doc.id)
                          }
                          className="w-10 h-10 "
                        >
                          <SearchRoundedIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={`${t("Card")} ${t("user")}`}>
                        <IconButton
                          onClick={() => handleOpenUserCard(doc.userId)}
                          className="w-10 h-10 "
                        >
                          <AssignmentIndRoundedIcon />
                        </IconButton>
                      </Tooltip>
                      {doc.status !== 6 ? (
                        <>
                          <Tooltip title={t("Discard")}>
                            <IconButton
                              onClick={() => handleRejectDocument(doc)}
                              disabled={isRejectLoading}
                            >
                              <HighlightOffRoundedIcon />
                            </IconButton>
                          </Tooltip>

                          <Tooltip
                            title={
                              doc.status === 3
                                ? t("Validate")
                                : t("ToValidateExt")
                            }
                          >
                            <IconButton
                              className="w-10 h-10"
                              onClick={() => handleChangeStatusDoc(doc)}
                            >
                              {doc.status === 3 ? (
                                <CheckCircleOutlineRoundedIcon className=" text-green-700" />
                              ) : (
                                <RadioButtonUncheckedRoundedIcon className=" text-gray" />
                              )}
                            </IconButton>
                          </Tooltip>
                        </>
                      ) : null}
                    </TableCell>
                  </TableRow>
                );
              })}
              <Popper
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                ref={popperRef}
              >
                <div
                  style={{
                    width: "350px",
                    backgroundColor: "white",
                    borderRadius: 20,
                  }}
                  className="shadow-lg p-4"
                >
                  <h3 className="p-4 m-0 text-center">{titleNote}</h3>
                  <Divider />
                  <p className="p-4">{noteEl}</p>
                </div>
              </Popper>
            </TableBody>
          )}
        </Table>
        <Divider />
        <div className="w-full flex justify-center">
          <CorePagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      </TableContainer>

      <CoreModal
        width={"100%"}
        height={"100%"}
        state={isModalDocComposition}
        onClose={() => {
          setIsModalDocComposition(false);
          setSelectedDoc(null);
        }}
        component={<DocComposition document={selectedDoc} />}
      />

      <CoreModal
        width={"100%"}
        height={"100%"}
        state={isSingleDocumentModalOpen}
        disableClose={true}
        component={
          <SingleDocumentPage
            document={singleDoc?.Data}
            closeModal={closeModal}
            documents={listIdDocs}
            onOpenDoc={handleOpenSingleDoc}
          />
        }
      />
      <CoreModal
        width={"100%"}
        height={"100%"}
        onClose={closeModal}
        state={isUserCardModalOpen}
        component={<SchedaUtente userId={selectedUserId} />}
      />
    </div>
  );
};

export default GestioneDocumentiTable;
